import { EPage } from '@types';

import { IPaths } from './model';

export const PAGES: Record<EPage, IPaths> = {
  [EPage.CART]: { internal: '/cart/', external: '/order-multistep.asp' },
  [EPage.UPSELLING]: { internal: '/upselling/', external: '/order2.asp' },
  [EPage.DELIVERY_AND_PAYMENT]: { internal: '/delivery-and-payment/', external: '/order4.asp' },
  [EPage.RESERVATION]: { internal: '/reservation/:cartId/', external: '/reservation-1/' },
  [EPage.RESERVATION_PAYMENT_AND_DELIVERY]: { external: '/reservation-2/' },
  [EPage.HOME_PAGE]: { external: '' },
  [EPage.CART_LOG_IN]: { external: '/order3.asp' },
  [EPage.PAYMENT_AND_DELIVERY]: { external: '/order4.asp' },
  [EPage.THANK_YOU]: { internal: '/thankyou/', external: '/order-summary2.asp' },
  [EPage.SUMMARY]: { internal: '/summary/', external: '/order5.asp' },
  [EPage.REPAY]: { internal: '/thankyou/repay', external: '' },
  [EPage.LOGIN_PAGE]: { external: '/login' },
  [EPage.REGISTER_PAGE]: { external: '/register' },
  [EPage.BENEFITS_PAGE]: { external: '/mynotino/customer-profile/' },
  [EPage.DISCOVERY_BOX]: { external: '/discovery-box' },
  [EPage.ADYEN_PAYMENT_REDIRECT_PAGE]: { internal: '/payment/adyen/redirect', external: '' },
  [EPage.GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE]: {
    internal: '/thankyou/payment/globalPayments/redirect/',
    external: '',
  },
  [EPage.GOPAY_PAYMENT_REDIRECT_PAGE]: {
    internal: '/thankyou/payment/gopay/redirect/',
    external: '',
  },

  [EPage.LOYALTY_PROGRAM]: { external: '/mynotino/club' },

  [EPage.PRZELEWY_PAYMENT_REDIRECT_PAGE]: { internal: '/payment/przelewy24/redirect', external: '' },
};

export enum RouteParams {
  AIRPLANE_DELIVERY = 'airplaneDelivery',
  REPAY = 'repay',
}
